// Module
var code = "<react-component name=\"ShowMembershipPlan\"></react-component>\n";
// Exports
module.exports = code;